// extracted by mini-css-extract-plugin
export default {"editorContent":"LAcFxXU2_WMbgRekynux"};